import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useModal } from '../../hooks/modalContext';

import * as Server from 'assets/js/Server';

const DiscountManage = () => {
  const { openModal } = useModal();

  const [discountCodeList, setDiscountCodeList] = useState([]);

  const getDiscountCodeList = () => {
    Server.sendGet('shopify/sales/discount/info', {}, getDiscountCodeListCallback).then();
  }

  const getDiscountCodeListCallback = res => {
    setDiscountCodeList(res?.['resultList']);
  }

  const handleAdd = () => {
    openModal({
      modalName: 'DiscountModal',
      modalData: {
        isRegi: true,
        data: {
          item: {},
          callback: getDiscountCodeList,
        },
      }
    });
  };

  const handleContent = item => {
    openModal({
      modalName: 'DiscountModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: getDiscountCodeList,
        },
      }
    });
  };

  useEffect(() => {
    getDiscountCodeList();
  }, []);

  return (
    <Inner>
      <Title>
        <TitHead>
          <i />
          <h4>Promo Code Manage</h4>
        </TitHead>
        <BtnDesc>
          {/* 등록 버튼 (파란색 강조를 위해 $Color 프롭 추가 예시) */}
          <TitBtn $Color onClick={handleAdd}>
            <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg' />
            <span>Discount Code Registration</span>
          </TitBtn>
        </BtnDesc>
      </Title>

      <Content>
        <Table>
          <colgroup>
            <col width='40%' />
            <col width='40%' />
            <col width='20%' />
          </colgroup>
          <thead>
          <tr>
            <th>Promo Code</th>
            <th>Incentive Per.</th>
            <th>Detail</th>
          </tr>
          </thead>
          <tbody>
          {/* 샘플 데이터 행 */}
          {discountCodeList?.map((item, idx) => (
            <>
              <tr key={idx}>
                <td>{item.discountCode}</td>
                <td>{item.incentive}</td>
                <td>
                  <TitBtn onClick={() => handleContent(item)}>
                    <span>Detail</span>
                  </TitBtn>
                </td>
              </tr>
            </>
          ))}
          </tbody>
        </Table>
      </Content>
    </Inner>
  );
}

/* --- 스타일 정의 (기존과 동일) --- */

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
  padding: 20px; /* 여백이 필요할 경우 대비 */
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    margin: 0;
  }
`;

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props.$Color ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  border: none;
  cursor: pointer;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props.$Color ? '#075C97' : '#7e7e7e')};
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 729px;
  overflow-y: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  & th {
    padding: 15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
  }

  & thead {
    top: 0;
    z-index: 1;
  }

  & tbody > tr {
    &:hover {
      background: #f4f4f4;
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

export default DiscountManage;
